    import React from 'react';
    import "./DeleteConfirmation.css";
    import { Modal } from 'react-bootstrap'
    import { useDispatch, useSelector, shallowEqual } from "react-redux";
    import { toast } from 'react-toastify';
    import { useNavigate } from 'react-router-dom';
    import question_icon from "../../assets/images/undraw_questions.svg"
    import { reload } from '../../utils/utils';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';

    const DeleteConfirmation = (props) => {

        const {processOngoing, show, handleNoClicked, title, id, handleYesClicked } = props;
        const dispatch = useDispatch();
        const states = useSelector((state) => state, shallowEqual);

    return (
        <Modal show={show} onHide={handleNoClicked} animation={true} className="rotateInDownLeft"  tabindex="-1" role="dialog" backdrop="static" aria-hidden="true">
                <div className="modal-content">
                    <div class="modal-header text-center py-1">
                        <h4 className="">Suppression</h4>
                        <button type="button" onClick={() => handleNoClicked(id)} class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                    <img src={question_icon} style={{width: "50%", height: "50%", marginLeft: "auto", marginRight: "auto", marginBottom: 15}} />
                        <p className="mb-3" id="exampleModalLabel">Etes-vous sûr de vouloir supprimer <span style={{color: "#F64A57", fontWeight: "bold"}}>{title}</span> </p>
                    </div>
                    <div className="modal-footer py-1">
                        <button style={{fontWeight: "bold"}}  className="btn" data-dismiss="modal" onClick={() => handleNoClicked(id)}><i className="flaticon-cancel-12"></i> NON</button>
                       {
                       processOngoing == false ? <button style={{fontWeight: "bold"}}  type="button" className="btn btn-danger ml-3" onClick={() => handleYesClicked(id)}>OUI</button>
                       : <ProcessSpinner />
                       }
                    </div>
                </div>
            </Modal>
    )
    }

    export default DeleteConfirmation